import React, { useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import DownloadIcon from '@mui/icons-material/Download';
import './leave-review.css';
import { useSelector } from 'react-redux';
import ApproveRejectCell from '../../../custom-cell-render/approve-reject-cell';
import { useParams } from 'react-router';
import { getAllLeaveOfEmployee } from '../../../../api-services/employee-services';
import jwt from 'jwt-decode';
import { JwtModel } from '../../../../model/token-model/token.model';
import { FcApproval } from "react-icons/fc";
import { AiFillCloseCircle, AiOutlineRedo } from "react-icons/ai";
import { Stack } from '@mui/system';
import LeaveReviewContainer from '../../../../componant/gridContainer/gridContainer';
import CustomDetailsCellRender from '../../../custom-details-cell-render/custom-details-cell-render';
import AgGridContainer from '../../../../componant/gridContainer/gridContainer';
import { TokenService } from '../../../../services/token.service';
import CustomTeamDetailsCell from '../../../custom-team-details-cell-render/customTeamDetailsCell';
import { formateHifDate } from '../../../../util_service/dateFormater/dateFormater';


const UserLeaveReview = () => {
    const [rowData, setRowData] = useState([]);
    const state = useSelector((state: any) => state.allEmployee);
    const params: any = useParams();
    const extractToken = TokenService.extractToken()
    useEffect(() => {

        getAllLeaveOfEmployee(extractToken?.sub).then((response: any) => {
            if (response?.data.success) {
                setRowData(response.data.payload.reverse());
            }
        })
    }, []);


    const columnDefs: any = [
        {
            headerName: "Name",
            field: "name",
            resizable: true,
            filter: true,
        },
        {
            headerName: "Leave Type",
            field: "leaveType",
            resizable: true,
            filter: true,
        },
        {
            headerName: "From Date",
            field: "fromDate",

            resizable: true,
            filter: true,
            cellRenderer: (params: any) => {
                const formattedValue = formateHifDate(params.value);
                return formattedValue;
            }
        },
        {
            headerName: "To Date",
            field: "toDate",

            resizable: true,
            filter: true,
            cellRenderer: (params: any) => {
                const formattedValue = formateHifDate(params.value);
                return formattedValue;
            }
        },
        {
            headerName: "Days",
            field: "noOfDays",

            resizable: true,
            filter: true,
        },
        {
            headerName: "Session",
            field: "session",

            resizable: true,
            filter: true,
        },
        {
            headerName: "Schedule ",
            field: "leavePeriod",

            resizable: true,
            filter: true,
        },
        {
            headerName: "Reason",
            field: "reasonForLeave",
            resizable: true,
            cellRenderer: (params: any) => (
                <CustomDetailsCellRender data={params} flag={false} title='Reason For Leave' />
            ),
        },
        {
            headerName: "Attachment",
            field: "attachment",
            resizable: true,
            filter: true,
            cellRenderer: (params: any) => {
                let content;
                if (params.data.attachment !== 'NA') {
                    const parts = params.data.attachment.split('_');
                    const filename = parts[parts.length - 1].trim();
                    const fileNames = filename;
                    content = (
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                            <div>{fileNames}</div>
                        </div>
                    );
                } else {
                    content = (
                        <div className='leave-review-field-container-no-file'>
                            {params.data.attachment}
                        </div>
                    );
                }

                return (
                    <div style={{ width: '100%' }}>
                        {content}
                    </div>
                );
            }
        },
        {
            headerName: "Action",
            field: "leaveStatus",
            resizable: true,
            filter: true,

            cellRenderer: (params: any) => (
                <>
                    <ApproveRejectCell value={params.data} handleEditEmployees={handleEditEmployees} onButtonAction={true} />
                </>

            ),
        },
    ];

    const handleEditEmployees = () => {

    }

    return (
        <div className='main'>
            <div className='main-container'>
                <div className='heading heading-start-center height-40'>
                    <h2>Leave Review</h2>
                </div>
                <div className='cal-40'>
                    <AgGridContainer rowData={rowData} columnDefs={columnDefs} />
                </div>
            </div >
        </div >
    )
}

export default UserLeaveReview